<template>
    <div>
        <div v-for="option in optionsFiltered" :key="option">
            <v-card
              elevation="2"
              v-if="isResolution"
              class="d-flex pa-4 mb-3"
              :class="{
                  'correct': option.studentCheck && option.is_correct,
                  'wrong': option.studentCheck && !option.is_correct,
                  'correct_answer': option.is_correct && !option.studentCheck
                }"
              >
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="option.studentCheck"
                    hide-details
                    readonly
                    class="pe-2 flex align-center"
                    />
                </v-col>
                <v-col cols=12>
                  <span v-html=option.answer></span>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              v-else
              class="d-flex pa-4 mb-3"
              elevation="0"
              :class="{'correct_answer': option.is_correct}"
            >
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="option.is_correct"
                  hide-details
                  readonly
                  class="pe-2 flex align-center"
                />
              </v-col>
              <v-col>
                <p v-html="option.answer" />
              </v-col>
            </v-row>
            </v-card>
        </div>
    </div>
</template>

<script>
import collect from 'collect.js'

export default {
  name: 'MutipleChoiceMutipleAnswerPreview',
  props: ['options', 'isResolution', 'answers'],
  computed: {
    optionsFiltered () {
      return collect(this.options)
        .values()
        .map(option => {
          const regex = /<iframe[^>]*src=["|']([^'"]+)["|'][^>]*>/g
          const answerFormated = this.formatAnswer(option.answer)
          const answer = option.answer.replace(regex, answerFormated)
          return { ...option, answer }
        })
        .all()
    }
  },
  methods: {
    formatAnswer (answer) {
      const iFrameRegex = /<iframe[^>]*src=["|']([^'"]+)["|'][^>]*>/g
      const widthRegex = /width=\S+/g
      const heightRegex = /height=\S+/g
      const match = answer.match(iFrameRegex)
      if (!match) {
        return
      }
      return match.toString()
        .replace(widthRegex, 'width="500"')
        .replace(heightRegex, 'height="350"')
        .replace('allowfullscreen="allowfullscreen"', '')
    }
  }
}
</script>

<style scoped>
.wrong {
  background-color: #ef9a9a;
}
.correct {
  background-color: #81c784;
}
.correct_answer {
  background-color: #7dbce6;
}

.text {
  font-weight: 900;
}
</style>
